document.querySelectorAll('[data-toggle="principles"]').forEach(el => {
    el.addEventListener('click', e => {
        e.preventDefault();
        var target = document.querySelector(el.getAttribute('href'));
        target.classList.toggle('active');
    });
});